const configSwitch = localStorage.getItem('configSwitch')

const user = {
  state: {
    configSwitch: configSwitch ? JSON.parse(configSwitch) : {},
    servicePhone: '',
    serviceEmail: '',
    // 全局展商不可操作弹框提示
    noActorTodo: false,
    // 全部身份或者观众不可操作弹框提示
    noVisitorTodo: false,
  },

  mutations: {
    SET_CONFIGSWITCH: (state, configSwitch) => {
      state.configSwitch = configSwitch || {}
      if (!configSwitch) {
        localStorage.removeItem('configSwitch')
      } else {
        localStorage.setItem('configSwitch', JSON.stringify(configSwitch))
      }
    },
    SET_SERVICEPHONE: (state, phone) => {
      state.servicePhone = phone
    },
    SET_SERVICEEMAIL: (state, email) => {
      state.serviceEmail = email
    },
    // 展商不可操作弹框状态改变
    setNoActorTodo(state, payload) {
      state.noActorTodo = payload
    },
    // 全部身份或者观众不可操作弹框提示
    setNoVisitorTodo(state, payload) {
      state.noVisitorTodo = payload
    }
  },

  actions: {
    
  }
}

export default user
